/**
 *  @ These are all the app specific constants we will be using:
 */
export const SESSION_STATE = 'SESSION_STATE';
export const SESSION_ID = 'SESSION_ID';
export const USER_DATA = 'USER_DATA';

export const USER_ROLES = [
  {
    label: 'Constituent Staff',
    short: 'Constituent Staff',
    value: 4,
  },
  {
    label: 'Staff Manager',
    short: 'Manager',
    value: 6,
  },
  {
    label: 'Member of Provincial Government',
    short: 'MPP',
    value: 5,
  },
  {
    label: 'Councillor',
    short: 'Councillor',
    value: 7,
  },
];

export const FEEDBACK_TYPES = [
  {
    label: 'Healthcare Access',
    value: 'Healthcare Access',
  },
  {
    label: 'Housing & Rent Issues',
    value: 'Housing & Rent Issues',
  },
  {
    label: 'Cost of Living / Inflation',
    value: 'Cost of Living / Inflation',
  },
  {
    label: 'Pensions & Seniors Services',
    value: 'Pensions & Seniors Services',
  },
  {
    label: 'Education & Schools',
    value: 'Education & Schools',
  },
  {
    label: 'Roads, Transit & Infrastructure',
    value: 'Roads, Transit & Infrastructure',
  },
  {
    label: 'Crime & Public Safety',
    value: 'Crime & Public Safety',
  },
  {
    label: 'Immigration & Federal Services',
    value: 'Immigration & Federal Services',
  },
  {
    label: 'Jobs & Employment Programs',
    value: 'Jobs & Employment Programs',
  },
  {
    label: 'Constituent Recognition / Event Requests',
    value: 'Constituent Recognition / Event Requests',
  },
  {
    label: 'Municipal Affairs and Issues',
    value: 'Municipal Affairs and Issues',
  },
  {
    label: 'Miscellaneous',
    value: 'Miscellaneous',
  },
  {
    label: 'Indigenous Affairs',
    value: 'Indigenous Affairs',
  },
  {
    label: 'Environmental Affairs / Cultural Affairs',
    value: 'Environmental Affairs / Cultural Affairs',
  },
  {
    label: 'Social Services',
    value: 'Social Services',
  },
];

export const SOCIAL_SERVICES_SUBTYPES = [
  {
    label: 'ODSP',
    value: 'ODSP',
  },
  {
    label: 'Ontario Works',
    value: 'Ontario Works',
  },
  {
    label: 'Community Housing',
    value: 'Community Housing',
  },
  {
    label: 'Homelessness',
    value: 'Homelessness',
  },
];

export const IMPORTANCE_TYPES = [
  {
    label: 'Critical',
    value: 3,
  },
  {
    label: 'Urgent',
    value: 2,
  },
  {
    label: 'Normal',
    value: 1,
  },
];

export const PARTIES_COLORS = [
  {
    id: 1,
    party: 'PC',
    color: '#1A4782',
  },
  {
    id: 2,
    party: 'Liberal',
    color: '#D71920',
  },
  {
    id: 3,
    party: 'NDP',
    color: '#F47D20',
  },
  {
    id: 4,
    party: 'Green',
    color: '#3D9B35',
  },
  {
    id: 5,
    party: 'New Blue',
    color: '#003366',
  },
  {
    id: 6,
    party: 'Ontario Party',
    color: '#4B0082',
  },
  {
    id: 7,
    party: 'Other',
    color: '#A0A0A0',
  },
  {
    id: 8,
    party: 'Libertarian',
    color: '#FFD700',
  },
  {
    id: 9,
    party: 'Electoral Reform Party',
    color: '#20B2AA',
  },
  {
    id: 10,
    party: 'Independent',
    color: '#CCCCCC',
  },
  {
    id: 11,
    party: 'Conservative Party of Canada',
    color: '#0C2C84',
  },
  {
    id: 12,
    party: 'Populist Party Ontario',
    color: '#800000',
  },
];

export const PROVINCIAL_RESULTS = [
  {
    name: 'PC',
    percentage: '42.97',
  },
  {
    name: 'Liberal',
    percentage: '29.95',
  },
  {
    name: 'NDP',
    percentage: '18.55',
  },
];

export const AUTH_METHOD_TYPES = [
  {
    label: 'Email',
    value: 'email',
  },
  {
    label: 'SMS',
    value: 'sms',
  },
];

export const NOTIFICATIONS_FREQUENCY_TYPES = [
  {
    label: 'Daily',
    value: 'Daily',
  },
  {
    label: 'Weekly',
    value: 'Weekly',
  },
  {
    label: 'Monthly',
    value: 'Monthly',
  },
  {
    label: 'After X messages',
    value: 'After X messages',
  },
];

export const PROTOCOL_TYPES = [
  {
    label: 'IMAP',
    value: 'IMAP',
  },
  {
    label: 'POP3',
    value: 'POP3',
  },
];

export const PROVIDER_TYPES = [
  {
    label: 'Gmail',
    value: 'Gmail',
  },
  {
    label: 'Outlook',
    value: 'Outlook',
  },
  {
    label: 'Yahoo',
    value: 'Yahoo',
  },
  {
    label: 'iCloud',
    value: 'iCloud',
  },
  {
    label: 'Office 365',
    value: 'Office 365',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

export const TIME_PERIOD_TYPES = [
  {
    label: 'Last 7 days',
    value: 7,
  },
  {
    label: 'Last 14 days',
    value: 14,
  },
  {
    label: 'Last 30 days',
    value: 30,
  },
  {
    label: 'Last 60 days',
    value: 60,
  },
  {
    label: 'Last 90 days',
    value: 90,
  },
  {
    label: 'Last 6 months',
    value: 180,
  },
  {
    label: 'Last 12 months',
    value: 365,
  },
  {
    label: 'All time',
    value: 'all',
  },
  {
    label: 'Custom',
    value: 'custom',
  },
];

export const TABLE_THEME = {
  palette: {
    primary: {
      main: '#3C5A7B',
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: '#3C5A7B',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#3C5A7B',
        },
      },
    },
  },
};

export const CASE_SOURCE_TYPES = [
  {
    label: 'Email',
    value: 'Email',
  },
  {
    label: 'Phone',
    value: 'Phone',
  },
  {
    label: 'Walk-in',
    value: 'Walk-in',
  },
];
